// Mock data for Brahmputra Infotech website

export const products = [
  {
    id: 1,
    title: "Desktop Computers",
    icon: "monitor"
  },
  {
    id: 2,
    title: "Laptops & Notebooks",
    icon: "laptop"
  },
  {
    id: 3,
    title: "Servers & Storage",
    icon: "server"
  },
  {
    id: 4,
    title: "Networking Equipment",
    icon: "network"
  },
  {
    id: 5,
    title: "IT Accessories",
    icon: "usb"
  },
  {
    id: 6,
    title: "Printers & Scanners",
    icon: "printer"
  }
];

export const services = [
  {
    id: 1,
    title: "GeM Procurement",
    icon: "shopping-cart"
  },
  {
    id: 2,
    title: "Bulk Supply & Fulfilment",
    icon: "package"
  },
  {
    id: 3,
    title: "Installation & Deployment",
    icon: "settings"
  },
  {
    id: 4,
    title: "AMC & After-Sales Support",
    icon: "headphones"
  }
];

export const partners = [
  { id: 1, name: "Prodot", logo: "https://logo.clearbit.com/prodotgroup.com" },
  { id: 2, name: "HP", logo: "https://logo.clearbit.com/hp.com" },
  { id: 3, name: "Zebronics", logo: "https://logo.clearbit.com/zebronics.com" },
  { id: 4, name: "Acer", logo: "https://logo.clearbit.com/acer.com" },
  { id: 5, name: "TVS Electronics", logo: "https://logo.clearbit.com/tvselectronics.in" },
  { id: 6, name: "Epson", logo: "https://logo.clearbit.com/epson.co.in" },
  { id: 7, name: "A&T", logo: "https://logo.clearbit.com/atnetindia.net" },
  { id: 8, name: "D-Link", logo: "https://logo.clearbit.com/dlink.com" },
  { id: 9, name: "CP Plus", logo: "https://logo.clearbit.com/cpplusworld.com" },
  { id: 10, name: "Elnova", logo: "https://logo.clearbit.com/elnova.com" },
  { id: 11, name: "Okaya", logo: "https://logo.clearbit.com/okaya.in" },
  { id: 12, name: "Microtek", logo: "https://logo.clearbit.com/microtek.in" },
  { id: 13, name: "Quick Heal", logo: "https://logo.clearbit.com/quickheal.com" },
  { id: 14, name: "Secureye", logo: "https://logo.clearbit.com/secureye.com" },
  { id: 15, name: "CyberX", logo: "https://logo.clearbit.com/cyberx.co.in" },
  { id: 16, name: "Net Protector", logo: "https://logo.clearbit.com/npav.com" },
  { id: 17, name: "Mantra", logo: "https://logo.clearbit.com/mantratec.com" },
  { id: 18, name: "Sparsh CCTV", logo: "https://logo.clearbit.com/sparshsecuritech.com" }
];

export const clients = [
  { id: 1, type: "Government Departments" },
  { id: 2, type: "Educational Institutions" },
  { id: 3, type: "Public Sector Organizations" },
  { id: 4, type: "Private Enterprises" }
];

export const whyChooseUs = [
  {
    id: 1,
    title: "Transparent Procurement Processes",
    icon: "eye"
  },
  {
    id: 2,
    title: "Compliance-Ready Documentation",
    icon: "file-check"
  },
  {
    id: 3,
    title: "On-Time Delivery",
    icon: "clock"
  },
  {
    id: 4,
    title: "Reliable After-Sales Support",
    icon: "shield-check"
  },
  {
    id: 5,
    title: "Structured Operations",
    icon: "briefcase"
  },
  {
    id: 6,
    title: "Competitive Pricing",
    icon: "badge-check"
  }
];

export const contactInfo = {
  location: "Guwahati, Assam, India",
  email: "info@brahmaputrainfotech.com",
  phone: "+91-XXXXXXXXXX"
};